module.exports = __webpack_public_path__ + "static/media/okcomply-basis.6b246379.png";